import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../styles';

const styles = css`
  .CommunityMapCard_wrapper {
    padding: 10px;
    min-width: 200px;
  }
  .CommunityMapCard_content {
    h4 {
      font-size: 16px;
      border-bottom: 1px solid ${colors.color2};
      padding-bottom: 5px;
    }
  }
  .CommunityMapCard_detailButton {
    display: block;
    background-image: url('/images/icon-arrow-gold.svg');
    background-position: right;
    background-repeat: no-repeat;
    span {
      color: #000000;
      font-size: 14px;
    }
  }
`;

function CommunityMapCard({ community }) {
  return (
    <div className={styles}>
      <div className="CommunityMapCard_wrapper">
        <div className="CommunityMapCard_inner">
          <div className="CommunityMapCard_content">
            <h4>{get(community, 'name')}</h4>
            <div className="CommunityMapCard_buttonWrapper">
              <Link name="community-detail" community={community} className="CommunityMapCard_detailButton">
                <span>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</span><br />
                <span>Priced from {numeral(get(community, 'priceLow')).format('$0,0')}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CommunityMapCard.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityMapCard;



// WEBPACK FOOTER //
// ./src/components/CommunityMapCard.js